import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  url = '@cec-api/report';

  constructor(private http: HttpClient) {}

  get(): Promise<any> {
    return this.http.get(this.url).toPromise();
  }

  getReport(data: any) {
    return this.http.post(this.url, data).toPromise();
  }
}
